export default {
    SET_VALIDATE_REQUEST_CANCELLATION_RESULT: (state, data) =>{
        state.validateRequestCancellationResult = data;
    },
    SET_CANCELLATION_SETTING: (state, data) =>{
        state.cancellationSetting = data;
    },
}